import { defineStyle } from '@chakra-ui/react';

export const headOptionVariant = defineStyle({
  cursor: 'pointer',
  border: '2px solid',
  backgroundColor: 'neutral.800',
  borderColor: 'neutral.800 !important',
  boxSizing: 'border-box',
  height: '56px',
  width: 'fit-content',
  paddingX: 1.5,
  textStyle: 'sm',
  transition: 'none',
  '&[data-active="true"]:not(:disabled)': {
    backgroundColor: 'blue.700',
    borderColor: 'blue.500  !important',
    _icon: {
      color: 'neutral.white',
    },
    color: 'neutral.white',
  },
  _disabled: {
    opacity: 1,
    _icon: {
      color: 'neutral.300',
    },
    color: 'neutral.300',
  },
  _hover: {
    _icon: {
      color: 'skyBlue  !important',
    },
  },
});
